<template>
  <!-- 右侧抽屉式弹窗 -->
  <el-drawer
    :visible.sync="visible"
    :with-header="false"
    direction="rtl"
    size="65%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="match-drawer"
    @closed="handleClosed"
  >
    <div class="drawer-container">
      <!-- 抽屉标题栏 -->
      <div class="drawer-header">
        <span class="drawer-title">手动匹配客户</span>
        <i class="el-icon-close drawer-close" @click="visible = false"></i>
      </div>

      <!-- 抽屉主体内容 -->
      <div class="drawer-body" v-loading="loading">
        <!-- 智为云更新企业信息 -->
        <div class="section-title">智为云更新企业信息</div>
        <div class="info-block">
          <div class="info-row">
            <span class="info-label">企业名称：</span>
            <span>{{ matchInfo.enterprise || "-" }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">证件类型 & 证件编号：</span>
          </div>
          <div class="cert-list">
            <div class="cert-item">
              <span>营业执照：</span>
              <span>{{ matchInfo.businessLicenseNumber || "-" }}</span>
            </div>
            <div class="cert-item">
              <span>诊所备案凭证：</span>
              <span>{{ matchInfo.clinicRecordNumber || "-" }}</span>
            </div>
            <div class="cert-item">
              <span>医疗执业许可证：</span>
              <span>{{ matchInfo.medicalPracticeLicenseNumber || "-" }}</span>
            </div>
          </div>
        </div>

        <!-- 匹配客户信息 -->
        <div class="section-title">匹配客户信息</div>
        <div class="match-tip">系统匹配到以下客户，请手动选择客户更新</div>
        <el-table
          :data="sortedMatchList"
          border
          height="100%"
          @row-click="handleRowClick"
        >
          <el-table-column width="55" align="center">
            <template slot-scope="{ row }">
              <el-radio
                v-model="selectedMatchId"
                :label="row.id"
                @click.native.stop
              >
                &nbsp;
              </el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="unitName" label="企业名称" align="center" />
          <el-table-column
            prop="certificateType"
            label="证件类型"
            align="center"
          >
            <template slot-scope="{ row }">
              {{ getCertificateTypeLabel(row.certificateType) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="certificateNumber"
            label="证件编号"
            align="center"
          />
          <el-table-column prop="erpCode" label="单位内码" align="center" />
          <el-table-column
            prop="updateTime"
            label="上次更新时间（智为云）"
            align="center"
          />
          <el-table-column label="操作" width="80" align="center">
            <template slot-scope="{ row }">
              <span class="btsed" @click.stop="openDetail(row)">详情</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 底部操作栏 -->
      <div class="drawer-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="confirmMatch">
          确认匹配，下一步
        </el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { getCustomerMatchInfo, updateMatchInfo } from "@/api/appApi/appapi.js";
export default {
  name: "CustomerMatchDialog",
  props: {
    // 抽屉显示状态（v-model）
    value: {
      type: Boolean,
      default: false,
    },
    // 待匹配客户ID（智为云推送的客户）
    customerId: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      visible: this.value,
      loading: false,
      btnLoading: false,
      matchInfo: {},
      matchList: [],
      selectedMatchId: null,
    };
  },
  computed: {
    // 按上次更新时间倒序排列，并去重
    sortedMatchList() {
      const map = new Map();
      (this.matchList || []).forEach((item) => {
        const key = item.id || item.erpCode;
        if (!key) return;
        if (!map.has(key)) {
          map.set(key, item);
        }
      });
      return Array.from(map.values()).sort((a, b) => {
        const timeA = new Date(a.updateTime || 0).getTime();
        const timeB = new Date(b.updateTime || 0).getTime();
        return timeB - timeA;
      });
    },
  },
  watch: {
    value(val) {
      this.visible = val;
      // if (val) this.loadData();
    },
    visible(val) {
      this.$emit("input", val);
      if (val) this.loadData();
    },
    customerId() {
      // if (this.visible) this.loadData();
    },
  },
  methods: {
    // 证件类型文案映射
    getCertificateTypeLabel(type) {
      const val = String(type ?? "");
      if (val === "1") return "营业执照";
      if (val === "2") return "医疗执业许可证";
      if (val === "3") return "诊所备案凭证";
      return type || "";
    },
    // 加载匹配信息
    async loadData() {
      if (!this.customerId) return;
      this.loading = true;
      this.selectedMatchId = null;
      const res = await getCustomerMatchInfo({ customerId: this.customerId });
      this.loading = false;
      if (res.code == "000000") {
        const content = res.content || {};
        this.matchInfo = content;
        this.matchList = content.matchCustomerList || [];
      }
    },
    // 点击行选中单选
    handleRowClick(row) {
      this.selectedMatchId = row.id;
    },
    // 新窗口打开集团客户详情
    openDetail(row) {
      const id = row && row.id;
      if (!id) return;
      console.log("跳转代入的token：", localStorage.getItem("token"));
      let route = this.$router.resolve({
        path: "/GroupCustomerList",
        query: {
          customerId: id,
          autoOpen: "1",
          unitName: row.unitName,
          certificateNumber: row.certificateNumber,
          token: localStorage.getItem("token"),
        },
      });
      window.open(route.href, "_blank");
    },
    // 确认匹配
    async confirmMatch() {
      if (!this.selectedMatchId) {
        this.$message.warning("请选择要匹配的客户");
        return;
      }
      this.btnLoading = true;
      const res = await updateMatchInfo({
        customerId: this.customerId,
        matchCustomerId: this.selectedMatchId,
      });
      this.btnLoading = false;
      if (res.code == "000000") {
        this.$message.success("匹配成功");
        this.visible = false;
        // 通知父组件进入经营范围维护
        this.$emit("success", this.customerId);
      }
    },
    // 抽屉关闭时重置状态
    handleClosed() {
      this.matchInfo = {};
      this.matchList = [];
      this.selectedMatchId = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
}
.drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e8eaec;
  flex-shrink: 0;
}
.drawer-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}
.drawer-close {
  font-size: 18px;
  color: #909399;
  cursor: pointer;
  &:hover {
    color: #303133;
  }
}
.drawer-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  padding-bottom: 70px;
  display: flex;
  flex-direction: column;
}
.drawer-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 15px 20px;
  background: #fff;
  border-top: 1px solid #e8eaec;
  text-align: right;
  z-index: 1;
}
.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 12px;
  flex-shrink: 0;
}
.info-block {
  background: #f5f7fa;
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 20px;
  flex-shrink: 0;
}
.info-row {
  margin-bottom: 8px;
  line-height: 24px;
}
.info-label {
  color: #606266;
}
.cert-list {
  padding-left: 12px;
}
.cert-item {
  line-height: 28px;
  color: #303133;
}
.match-tip {
  color: #606266;
  margin-bottom: 12px;
  font-size: 13px;
  flex-shrink: 0;
}
</style>

<style lang="scss">
/* 抽屉全局样式（custom-class 挂载在 body 下，需非 scoped） */
.match-drawer {
  .el-drawer__body {
    padding: 0;
    overflow: hidden;
  }
}
@media screen and (max-width: 768px) {
  .match-drawer.el-drawer.rtl {
    width: 90% !important;
  }
}
</style>
